module.exports = __webpack_public_path__ + "img/nodata.09b8e99c.png";